import { type ReactNode } from "react";

interface ShimmerProps {
  className?: string;
  children?: ReactNode;
  style?: React.CSSProperties;
}

export default function Shimmer({ className = "", children, style }: ShimmerProps) {
  return (
    <div style={style} className={`relative overflow-hidden bg-background-200/50 ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/40 to-transparent" />
      {children}
    </div>
  );
}